// extracted by mini-css-extract-plugin
export default {"modal":"CloneExamModal_modal__ngCOq","modalContent":"CloneExamModal_modalContent__eQSqH","close":"CloneExamModal_close__VnwaQ","cloneButton":"CloneExamModal_cloneButton__XRSQ9"};